/**
 * Whether the conversation's bottom fade (next-chat-layout.css) should
 * paint (agion/Agion#2612 item 4). The fade is decorative: it tells the
 * person content is scrolling behind the composer, so it belongs only when
 * both are true — the composer renders, and the thread's content is
 * actually taller than the scroll region. Without a composer there is
 * nothing to fade toward; without overflow there is no "behind" for the
 * fade to describe, and it reads instead as a stray band under a short,
 * finished conversation.
 */
export function shouldShowChatFade(
  scrollEl: Pick<HTMLElement, 'scrollHeight' | 'clientHeight'> | null,
  composerVisible: boolean,
): boolean {
  if (!composerVisible || !scrollEl) return false
  return scrollEl.scrollHeight > scrollEl.clientHeight + 1
}
